import React from 'react';

import Spinner from 'react-spinner-material';
import {
  GraphBarCustomLateral,
  GraphBarExpansivCard,
  GraphBarGrouped,
  GraphBarGroupedSimple,
  NewGraphBar,
  NewGraphBarCustom,
  NewGraphBarPorte,
  PizzaChart,
} from '../../utils/newGraphsBar';
import styles from './styles.module.scss';

export default function DashboardRegistroSas({
  registroSas,
  usuariosUnicos,
  perfilUsuario,
  porcemPerfilUsuarioUnico,
  mediaAtendimentoUsuario,
  mediaAtendimentoUsuarioPf,
  mediaAtendimentoUsuarioPj,
  porteTipoInstrumento,
  mediaAtendimentoPorte,
  atendimentoPorte,
  atendimentosHora,
  atendimentoUf,
  tipoAtendimentoAPC,
  tipoAtendimentoAPS,
  tipoAtendimentoAPB,
  tipoAtendimentoAPM,
  tipoAtendimentoAPA,
  tipoAtendimentoAPD,
  tipoAtendimentoAPL,
  tipoAtendimentoAPR,
  tipoAtendimentoAPE,
  tipoAtendimentoAPN,
  tipoAtendimentoAPF,
  tipoAtendimentoAPO,
  statusEnvioSAS,
  porcemEnvioSAS,
  envioInstrumentoSAS,
  recorrenciaPjSas,
  recorrenciaPjMeiSas,
  recorrenciaPjMeSas,
  recorrenciaPjEppSas,

  // isLoading,
  isLoadingSas,
  isLoadingUserUnico,
  isLoadingPerfilUser,
  isLoadingPorcemPerfilUserUnico,
  isLoadingMediaAtendiUser,
  isLoadingMediaAtendUserPf,
  isLoadingMediaAtendUserPj,
  isLoadingPorteTipoInstru,
  isLoadingAtendPorte,
  isLoadingMediaAtendPorte,
  isLoadingAtendHora,
  isLoadingAtendUF,
  isLoadingAPC,
  isLoadingAPS,
  isLoadingAPB,
  isLoadingAPM,
  isLoadingAPA,
  isLoadingAPD,
  isLoadingAPL,
  isLoadingAPR,
  isLoadingAPE,
  isLoadingAPN,
  isLoadingAPF,
  isLoadingAPO,
  isLoadingStatusEnvioSAS,
  isLoadingPorcemEnvioSAS,
  isLoadingEnvioInstrumentoSAS,
  isLoadingRecorrenciaPjSas,
  isLoadingRecorrenciaPjMeiSas,
  isLoadingRecorrenciaPjMeSas,
  isLoadingRecorrenciaPjEppSas,
}) {
  const renderRegistroSas = () => (
    <div className={isLoadingSas ? styles.render_spinner_container : null}>
      {isLoadingSas && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingSas && (
        <NewGraphBar
          dataGraphs={registroSas?.atendimentos}
          total={
            registroSas?.total === 0 ||
            registroSas?.total === 'NaN' ||
            registroSas?.total === undefined
              ? '0'
              : registroSas?.total
          }
          label="registros SAS"
          position="mes*total"
          subLabel="Registros de atendimentos"
          labelModal="total"
          date={registroSas?.data}
        />
      )}
    </div>
  );

  const renderUsuariosUnicos = () => (
    <div
      className={isLoadingUserUnico ? styles.render_spinner_container : null}
    >
      {isLoadingUserUnico && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingUserUnico && (
        <NewGraphBar
          dataGraphs={usuariosUnicos?.atendimentos}
          total={
            usuariosUnicos?.total === 0 ||
            usuariosUnicos?.total === 'NaN' ||
            usuariosUnicos?.total === undefined
              ? '0'
              : usuariosUnicos?.total
          }
          label="usuários únicos"
          position="mes*total"
          subLabel="Usuários únicos"
          date={usuariosUnicos?.data}
        />
      )}
    </div>
  );

  const renderPerfilUsuario = () => (
    <div
      className={isLoadingPerfilUser ? styles.render_spinner_container : null}
    >
      {isLoadingPerfilUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}

      {!isLoadingPerfilUser && (
        <GraphBarGrouped
          dataGraphs={perfilUsuario?.atendimentos}
          label="perfil do usuário"
          porcemPf={
            perfilUsuario?.porcentagemPf === 'NaN' ||
            perfilUsuario?.porcentagemPf === undefined ||
            perfilUsuario?.porcentagemPf === 0
              ? '0'
              : perfilUsuario?.porcentagemPf.toFixed(2)
          }
          porcemPj={
            perfilUsuario?.porcentagemPj === 'NaN' ||
            perfilUsuario?.porcentagemPj === undefined ||
            perfilUsuario?.porcentagemPj === 0
              ? '0'
              : perfilUsuario?.porcentagemPj.toFixed(2)
          }
          position="dia*total"
          date={perfilUsuario?.data}
          iten1="PF"
          iten2="PJ"
          porcemSimbol="%"
        />
      )}
    </div>
  );

  const renderMediaAtendimentoUsuario = () => (
    <div
      className={
        isLoadingMediaAtendiUser ? styles.render_spinner_container : null
      }
    >
      {isLoadingMediaAtendiUser ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={mediaAtendimentoUsuario?.atendimentos}
          total={
            mediaAtendimentoUsuario?.média === 'NaN'
              ? 0
              : mediaAtendimentoUsuario?.média.toFixed(2)
          }
          label="média por usuário"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={mediaAtendimentoUsuario?.data}
        />
      )}
    </div>
  );
  const renderMediaAtendimentoUsuarioPf = () => (
    <div
      className={
        isLoadingMediaAtendUserPf ? styles.render_spinner_container : null
      }
    >
      {isLoadingMediaAtendUserPf ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={mediaAtendimentoUsuarioPf?.atendimentos}
          total={
            mediaAtendimentoUsuarioPf?.média === 'NaN'
              ? 0
              : mediaAtendimentoUsuarioPf?.média?.toFixed(2)
          }
          label="média PF únicos"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="media"
          date={mediaAtendimentoUsuarioPf?.data}
        />
      )}
    </div>
  );
  const renderMediaAtendimentoUsuarioPj = () => (
    <div
      className={
        isLoadingMediaAtendUserPj ? styles.render_spinner_container : null
      }
    >
      {isLoadingMediaAtendUserPj ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={mediaAtendimentoUsuarioPj?.atendimentos}
          total={mediaAtendimentoUsuarioPj?.média?.toFixed(2)}
          label="média PJ únicos"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="media"
          date={mediaAtendimentoUsuarioPj?.data}
        />
      )}
    </div>
  );
  const renderPorteTipoInstrumento = () => (
    <div
      className={
        isLoadingPorteTipoInstru ? styles.render_spinner_container : null
      }
    >
      {isLoadingPorteTipoInstru ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBarCustom
          dataGraphs={porteTipoInstrumento}
          total1={
            porteTipoInstrumento[0]?.totalAtendimentos === 'NaN' ||
            porteTipoInstrumento[0]?.totalAtendimentos === undefined ||
            porteTipoInstrumento[0]?.totalAtendimentos === null ||
            porteTipoInstrumento[0]?.totalAtendimentos === 0
              ? '0'
              : porteTipoInstrumento[0]?.totalAtendimentos
          }
          total2={
            porteTipoInstrumento[1]?.totalAtendimentos === 'NaN' ||
            porteTipoInstrumento[1]?.totalAtendimentos === undefined ||
            porteTipoInstrumento[1]?.totalAtendimentos === null ||
            porteTipoInstrumento[1]?.totalAtendimentos === 0
              ? '0'
              : porteTipoInstrumento[1]?.totalAtendimentos
          }
          total3={
            porteTipoInstrumento[2]?.totalAtendimentos === 'NaN' ||
            porteTipoInstrumento[2]?.totalAtendimentos === undefined ||
            porteTipoInstrumento[2]?.totalAtendimentos === null ||
            porteTipoInstrumento[2]?.totalAtendimentos === 0
              ? '0'
              : porteTipoInstrumento[2]?.totalAtendimentos
          }
          label="tipo instrumento"
          position="descricao*totalAtendimentos"
        />
      )}
    </div>
  );

  const renderAtendimentosPorte = () => (
    <div
      className={isLoadingAtendPorte ? styles.render_spinner_container : null}
    >
      {isLoadingAtendPorte ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBarPorte
          dataGraphs={atendimentoPorte?.atendimentos}
          total={
            atendimentoPorte?.total === 0 ||
            atendimentoPorte?.total === 'NaN' ||
            atendimentoPorte?.total === undefined
              ? '0'
              : atendimentoPorte?.total
          }
          label="por porte empresa"
          labelModal="por porte"
          subLabel="Usuários únicos PJ"
          position="sigla*total"
          slModal={atendimentoPorte?.slModal}
        />
      )}
    </div>
  );

  const renderMediaAtendimentosPorte = () => (
    <div
      className={
        isLoadingMediaAtendPorte ? styles.render_spinner_container : null
      }
    >
      {isLoadingMediaAtendPorte ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        // prettier-ignore
        <NewGraphBarPorte
          dataGraphs={mediaAtendimentoPorte?.atendimentos}
          total={
            mediaAtendimentoPorte?.média === 'NaN'
              ? 0
              : (mediaAtendimentoPorte?.média?.toFixed(2))
          }
          label="média PJ únicos por porte"
          subLabel="Registro por usuário (média)"
          labelModal='Média PJ únicos (porte)'
          position="sigla*média"
          axisY='media'
          date={mediaAtendimentoPorte?.data}
          slModal={mediaAtendimentoPorte?.slModal}
        />
      )}
    </div>
  );

  const renderAtendimentosHora = () => (
    <div
      className={isLoadingAtendHora ? styles.render_spinner_container : null}
    >
      {isLoadingAtendHora ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={atendimentosHora.atendimentosHora}
          total={
            atendimentosHora?.total === 0 ||
            atendimentosHora?.total === 'NaN' ||
            atendimentosHora?.total === undefined ||
            atendimentosHora?.total === null
              ? '0'
              : atendimentosHora?.total
          }
          label="distribuição no dia"
          subLabel="Registro do dia"
          labelModal="Distribuição por hora:"
          position="hora*total"
          date={atendimentosHora?.horaModal}
        />
      )}
    </div>
  );

  const renderAtendimentoUf = () => (
    <div
      className={
        isLoadingPerfilUser ? styles.render_spinner_container_ufs : null
      }
    >
      {isLoadingPerfilUser ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarCustomLateral
          dataGraphsAtendUf={atendimentoUf?.atendimentos}
          dataGraphsUserUf={atendimentoUf?.atendimentosUnicos}
          position="uf*total"
          tab1="Atendim. por UF"
          tab2="Usuários únicos UF"
          titleUF={atendimentoUf?.descUf2}
          titleUF2={atendimentoUf?.descUf}
        />
      )}
    </div>
  );
  const renderPorcemPerfilUsuarioUnico = () => (
    <div
      className={
        isLoadingPorcemPerfilUserUnico ? styles.render_spinner_container : null
      }
    >
      {isLoadingPorcemPerfilUserUnico ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <PizzaChart
          item1Pf="PF"
          item2Pj="PJ"
          label="perfil usuário único"
          porcemPf={
            porcemPerfilUsuarioUnico?.porcentagemPf === 'NaN' ||
            porcemPerfilUsuarioUnico?.porcentagemPf === undefined
              ? 0
              : porcemPerfilUsuarioUnico?.porcentagemPf
          }
          porcemPj={
            porcemPerfilUsuarioUnico?.porcentagemPj === 'NaN' ||
            porcemPerfilUsuarioUnico?.porcentagemPj === undefined
              ? 0
              : porcemPerfilUsuarioUnico?.porcentagemPj
          }
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPC = () => (
    <div className={isLoadingAPC ? styles.render_spinner_container : null}>
      {isLoadingAPC ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPC?.atendimentos}
          total={
            tipoAtendimentoAPC?.total === 0 ||
            tipoAtendimentoAPC?.total === 'NaN' ||
            tipoAtendimentoAPC?.total === undefined
              ? '0'
              : tipoAtendimentoAPC?.total
          }
          label="APC"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPC?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPS = () => (
    <div className={isLoadingAPS ? styles.render_spinner_container : null}>
      {isLoadingAPS ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPS?.atendimentos}
          total={
            tipoAtendimentoAPS?.total === 0 ||
            tipoAtendimentoAPS?.total === 'NaN' ||
            tipoAtendimentoAPS?.total === undefined
              ? '0'
              : tipoAtendimentoAPS?.total
          }
          label="APS"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPS?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPB = () => (
    // <div className="render-apb">
    <div
      className={isLoadingAPB ? styles.render_spinner_container : 'render-apb'}
    >
      {isLoadingAPB ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPB?.atendimentos}
          total={
            tipoAtendimentoAPB?.total === 0 ||
            tipoAtendimentoAPB?.total === 'NaN' ||
            tipoAtendimentoAPB?.total === undefined
              ? '0'
              : tipoAtendimentoAPB?.total
          }
          label="APB"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPB?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPM = () => (
    <div className={isLoadingAPM ? styles.render_spinner_container : null}>
      {isLoadingAPM ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPM?.atendimentos}
          total={
            tipoAtendimentoAPM?.total === 0 ||
            tipoAtendimentoAPM?.total === 'NaN' ||
            tipoAtendimentoAPM?.total === undefined
              ? '0'
              : tipoAtendimentoAPM?.total
          }
          label="APM"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPM?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPA = () => (
    <div className={isLoadingAPA ? styles.render_spinner_container : null}>
      {isLoadingAPA ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPA?.atendimentos}
          total={
            tipoAtendimentoAPA?.total === 0 ||
            tipoAtendimentoAPA?.total === 'NaN' ||
            tipoAtendimentoAPA?.total === undefined
              ? '0'
              : tipoAtendimentoAPA?.total
          }
          label="APA"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPA?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPD = () => (
    <div className={isLoadingAPD ? styles.render_spinner_container : null}>
      {isLoadingAPD ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPD?.atendimentos}
          total={
            tipoAtendimentoAPD?.total === 0 ||
            tipoAtendimentoAPD?.total === 'NaN' ||
            tipoAtendimentoAPD?.total === undefined
              ? '0'
              : tipoAtendimentoAPD?.total
          }
          label="APD"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPD?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPL = () => (
    <div className={isLoadingAPL ? styles.render_spinner_container : null}>
      {isLoadingAPL ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPL?.atendimentos}
          total={
            tipoAtendimentoAPL?.total === 0 ||
            tipoAtendimentoAPL?.total === 'NaN' ||
            tipoAtendimentoAPL?.total === undefined
              ? '0'
              : tipoAtendimentoAPL?.total
          }
          label="APL"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPL?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPR = () => (
    <div className={isLoadingAPR ? styles.render_spinner_container : null}>
      {isLoadingAPR ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPR?.atendimentos}
          total={
            tipoAtendimentoAPR?.total === 0 ||
            tipoAtendimentoAPR?.total === 'NaN' ||
            tipoAtendimentoAPR?.total === undefined
              ? '0'
              : tipoAtendimentoAPR?.total
          }
          label="APR"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPR?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPE = () => (
    <div className={isLoadingAPE ? styles.render_spinner_container : null}>
      {isLoadingAPE ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPE?.atendimentos}
          total={
            tipoAtendimentoAPE?.total === 0 ||
            tipoAtendimentoAPE?.total === 'NaN' ||
            tipoAtendimentoAPE?.total === undefined
              ? '0'
              : tipoAtendimentoAPE?.total
          }
          label="APE"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPE?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPN = () => (
    <div className={isLoadingAPN ? styles.render_spinner_container : null}>
      {isLoadingAPN ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={tipoAtendimentoAPN?.atendimentos}
          total={
            tipoAtendimentoAPN?.total === 0 ||
            tipoAtendimentoAPN?.total === 'NaN' ||
            tipoAtendimentoAPN?.total === undefined
              ? '0'
              : tipoAtendimentoAPN?.total
          }
          label="APN"
          subLabel="Registros"
          position="mes*total"
          date={tipoAtendimentoAPN?.data}
        />
      )}
    </div>
  );

  const renderTipoAtendimentoAPF = () => (
    <div className={isLoadingAPF ? styles.render_spinner_container : null}>
      {isLoadingAPF ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarExpansivCard
          dataGraphs={tipoAtendimentoAPF?.atendimentos}
          total={
            tipoAtendimentoAPF?.total === 0 ||
            tipoAtendimentoAPF?.total === 'NaN' ||
            tipoAtendimentoAPF?.total === undefined
              ? '0'
              : tipoAtendimentoAPF?.total
          }
          label="APF"
          subLabel="Registros"
          position="mes*total"
          ccPj={tipoAtendimentoAPF?.contaCorrente}
          maquininhas={tipoAtendimentoAPF?.maquininha}
          servContabil={tipoAtendimentoAPF?.servicosContabeis}
          date={tipoAtendimentoAPF?.data}
        />
      )}
    </div>
  );
  const renderTipoAtendimentoAPO = () => (
    <div className={isLoadingAPO ? styles.render_spinner_container : null}>
      {isLoadingAPO ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarExpansivCard
          dataGraphs={tipoAtendimentoAPO?.atendimentos}
          total={
            tipoAtendimentoAPO?.total === 0 ||
            tipoAtendimentoAPO?.total === 'NaN' ||
            tipoAtendimentoAPO?.total === undefined
              ? '0'
              : tipoAtendimentoAPO?.total
          }
          label="APO"
          subLabel="Registros"
          position="mes*total"
          oport={tipoAtendimentoAPO?.oportunidade}
          mLocal={tipoAtendimentoAPO?.melhorLocal}
          date={tipoAtendimentoAPO?.data}
        />
      )}
    </div>
  );

  const renderStatusEnvioSAS = () => (
    <div
      className={
        isLoadingStatusEnvioSAS ? styles.render_spinner_container : null
      }
    >
      {isLoadingStatusEnvioSAS && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}

      {!isLoadingStatusEnvioSAS && (
        <GraphBarGrouped
          dataGraphs={statusEnvioSAS?.atendimentos}
          // title="Registros SAS"
          label="status envio OK"
          porcemPf={
            statusEnvioSAS?.enviados === 'NaN' ||
            statusEnvioSAS?.enviados === undefined ||
            statusEnvioSAS?.enviados === 0
              ? '0'
              : statusEnvioSAS?.enviados
          }
          porcemPj={
            statusEnvioSAS?.naoEnviados === 'NaN' ||
            statusEnvioSAS?.naoEnviados === undefined ||
            statusEnvioSAS?.naoEnviados === 0
              ? '0'
              : statusEnvioSAS?.naoEnviados
          }
          position="dia*total"
          date={statusEnvioSAS?.data}
          iten1="enviados"
          iten2="não enviados"
          // porcemSimbol="%"
        />
      )}
    </div>
  );

  const renderPorcemEnvioSAS = () => (
    <div
      className={
        isLoadingPorcemEnvioSAS ? styles.render_spinner_container : null
      }
    >
      {isLoadingPorcemEnvioSAS ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <PizzaChart
          item1Pf="enviados"
          item2Pj="não enviados"
          label="% envio OK"
          porcemPf={
            porcemEnvioSAS?.enviados === 'NaN' ||
            porcemEnvioSAS?.enviados === undefined
              ? 0
              : porcemEnvioSAS?.enviados
          }
          porcemPj={
            porcemEnvioSAS?.naoEnviados === 'NaN' ||
            porcemEnvioSAS?.naoEnviados === undefined
              ? 0
              : porcemEnvioSAS?.naoEnviados
          }
        />
      )}
    </div>
  );

  const renderEnvioInstrumentoSAS = () => (
    <div
      className={
        isLoadingEnvioInstrumentoSAS ? styles.render_spinner_container : null
      }
    >
      {isLoadingEnvioInstrumentoSAS && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}

      {!isLoadingEnvioInstrumentoSAS && (
        <GraphBarGroupedSimple
          dataGraphs={envioInstrumentoSAS?.atendimentos}
          label="envio instrumento"
          itemTotal1={
            envioInstrumentoSAS?.enviadosTotal === 'NaN' ||
            envioInstrumentoSAS?.enviadosTotal === undefined ||
            envioInstrumentoSAS?.enviadosTotal === 0
              ? '0'
              : envioInstrumentoSAS?.enviadosTotal
          }
          itemTotal2={
            envioInstrumentoSAS?.naoEnviadosTotal === 'NaN' ||
            envioInstrumentoSAS?.naoEnviadosTotal === undefined ||
            envioInstrumentoSAS?.naoEnviadosTotal === 0
              ? '0'
              : envioInstrumentoSAS?.naoEnviadosTotal
          }
          position="descricao*total"
          iten1="enviados"
          iten2="não enviados"
        />
      )}
    </div>
  );

  return (
    <div className={styles.central_container}>
      <div className={styles.render_big_container}>
        <div className={styles.render_big_container2}>
          <div className={styles.render_graph_container1}>
            {renderRegistroSas()}
            {renderUsuariosUnicos()}
            {renderAtendimentosHora()}
            {renderPerfilUsuario()}
          </div>
          <div className={styles.render_graph_container1}>
            {renderMediaAtendimentoUsuario()}
            {renderMediaAtendimentoUsuarioPf()}
            {renderMediaAtendimentoUsuarioPj()}
            {renderMediaAtendimentosPorte()}
          </div>
        </div>
        <div className={styles.graphBar_lateral_container}>
          {renderAtendimentoUf()}
        </div>
      </div>
      <div className={styles.render_big_container3}>
        <div className={styles.render_graph_container2}>
          {renderAtendimentosPorte()}
          {renderPorteTipoInstrumento()}
          {renderPorcemPerfilUsuarioUnico()}
          {renderTipoAtendimentoAPA()}
          {renderTipoAtendimentoAPB()}
        </div>
        <div className={styles.render_graph_container2}>
          {renderTipoAtendimentoAPC()}
          {renderTipoAtendimentoAPD()}
          {renderTipoAtendimentoAPE()}
          {renderTipoAtendimentoAPF()}
          {renderTipoAtendimentoAPL()}
        </div>
        <div className={styles.render_graph_container2}>
          {renderTipoAtendimentoAPM()}
          {renderTipoAtendimentoAPN()}
          {renderTipoAtendimentoAPO()}
          {renderTipoAtendimentoAPR()}
          {renderTipoAtendimentoAPS()}
        </div>
        <div className={styles.render_graph_container2}>
          {renderStatusEnvioSAS()}
          {renderPorcemEnvioSAS()}
          {renderEnvioInstrumentoSAS()}
        </div>
      </div>
    </div>
  );
}
